export const formatCurrency = (value, currency = 'USD') => {
  if (typeof value === 'string') value = parseFloat(value.replace(/,/g, ''));
  if (isNaN(value)) return '';

  const locales = {
    INR: 'en-IN',
    GBP: 'en-GB',
    USD: 'en-US',
    CAD: 'en-CA',
    EUR: 'en-IE',
    SGD: 'en-SG'
  };
  const locale = locales[currency] || 'en-US';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  } catch {
    // fallback to plain number if currency fails
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
};


export default formatCurrency;


